// Module
var code = `<write-text-about ng-model="programFamilyFormDatum.shortAnswerScholarship" min-chars="minChars" max-chars="maxChars" textarea-class="{{textareaClass}}" ng-required="isRequired"></write-text-about>`;
// Exports
export default code;